<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: 'FocusManage'
    };
</script>

<style lang="less" scoped>
</style>
